<template>
    <b-modal id="userModal"
             :hide-footer="!userValidated"
             :title="(editUser && editUser.id) ? 'Edit User' : 'Create user'"
             ok-title="Save"
             centered
             size="lg"
             @ok="saveUser"
             @shown="setupUser()"
             @hidden="setupUser()"
    >

        <div v-if="editUser !== null">


            <b-input-group prepend="E-mail address" class="mt-3">
                <b-form-input
                    id="user_email"
                    :state="errors.email === null"
                    @change="errors.email = null"
                    v-model="editUser.email"
                    type="email"
                    required
                    :disabled="userValidated"
                    placeholder="E-mail"
                ></b-form-input>
                <b-input-group-append>
                    <b-button v-if="!userValidated" variant="outline-success" @click="checkForExistingUser">Validate
                    </b-button>
                    <b-button v-else variant="outline-success" @click="userValidated = false">Modify e-mail</b-button>
                </b-input-group-append>


                <template v-if="errors.email !== null">
                    <b-form-invalid-feedback v-for="(error, key) in errors.email" :key="'email_error_' + key">
                        {{ error }}
                    </b-form-invalid-feedback>
                </template>
            </b-input-group>

            <template v-if="userValidated">

                <b-input-group prepend="Name" class="mt-3">
                    <b-form-input
                        id="user_name"
                        :state="errors.name === null"
                        @change="errors.name = null"
                        v-model="editUser.name"
                        type="text"
                        required
                        autocomplete="name"
                        placeholder="Name"
                    ></b-form-input>

                    <template v-if="errors.name !== null">
                        <b-form-invalid-feedback v-for="(error, key) in errors.name" :key="'name_error_' + key">
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-input-group>


                <b-input-group prepend="Role" class="mt-3">
                    <b-form-select
                        :state="errors['role.id'] === null"
                        @change="errors['role.id'] = null"
                        class="form-control"
                        placeholder="Role"
                        v-model="editUser.role.id"
                        required>
                        <b-form-select-option v-for="(role, key) in roles" :key="'role_' + role.id + '_' + key" :value="role.id">
                            {{ role.name }}
                        </b-form-select-option>
                    </b-form-select>

                    <template v-if="errors['role.id'] !== null">
                        <b-form-invalid-feedback v-for="(error, key) in errors['role.id']" :key="'role_error_' + key">
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-input-group>


                <div class="input-group mt-3">
                    <verte :picker="'wheel'" model="rgb"
                           :state="errors.color === null"
                           @change="errors.color = null"
                           v-model="editUser.color" :model="'hex'" :enableAlpha="false"
                           :rgbSliders="false"></verte>
                    &nbsp;
                    <input type="text" placeholder="Color" class="form-control" required
                           v-model="editUser.color" disabled/>

                    <template v-if="errors.color !== null">
                        <b-form-invalid-feedback v-for="(error, key) in errors.color" :key="'color_error' + key" force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </div>

                <hr/>
                <p v-if="editUser.id !== null">Leave the password empty if you don't want to change it</p>

                <b-input-group prepend="Password" class="mt-3">
                    <b-form-input
                        id="user_password"
                        :state="errors.password === null"
                        @change="errors.password = null"
                        v-model="password"
                        type="password"
                        required
                        placeholder="Password"
                    ></b-form-input>

                    <template v-if="errors.password !== null">
                        <b-form-invalid-feedback v-for="(error, key) in errors.password" :key="'password_error_' + key" force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-input-group>

                <b-input-group prepend="Repeat Password" class="mt-3">
                    <b-form-input
                        id="user_password_confirmation"
                        :state="errors.password_confirmation === null"
                        @change="errors.password_confirmation = null"
                        v-model="password_confirmation"
                        type="password"
                        required
                        placeholder="Repeat Password"
                    ></b-form-input>

                    <template v-if="errors.password_confirmation !== null">
                        <b-form-invalid-feedback v-for="(error, key) in errors.password_confirmation" :key="'password_confirmation_error_' + key" force-show>
                            {{ error }}
                        </b-form-invalid-feedback>
                    </template>
                </b-input-group>

            </template>

        </div>
    </b-modal>
</template>

<script>

import {cloneDeep} from "lodash";
import axios from "axios";

import Verte from 'verte';
import 'verte/dist/verte.css';

export default {
    components: {Verte},
    name: "UserModal",
    props: {
        user: {
            type: Object,
            required: false,
            default: null
        },
        isReseller: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            editUser: null,
            userValidated: false,
            roleArray: [
                {name: 'Outside inspector', id: 6, is_unique: false},
                {name: 'Subcontractor', id: 5, is_unique: false},
                {name: 'User', id: 4, is_unique: true},
                {name: 'Project Manager', id: 3, is_unique: true},
                {name: 'Company Manager', id: 2, is_unique: true},
                {name: 'Admin', id: 1, is_unique: true},
            ],
            password: null,
            password_confirmation: null,
            errors: {
                email: null,
                name: null,
                'role.id': null,
                color: null,
                password: null,
                password_confirmation: null
            }
        };
    },

    methods: {
        setupUser() {
            this.editUser = cloneDeep(this.user);
            this.userValidated = !!(this.editUser && this.editUser.id);
            this.errors = {
                email: null,
                name: null,
                'role.id': null,
                color: null,
                password: null,
                password_confirmation: null
            };
        },
        validateEmail(mail) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
        },
        checkForExistingUser() {
            if (this.editUser.email && this.validateEmail(this.editUser.email)) {
                let token = this.$store.state.token;

                const method = 'POST';
                const url = this.$store.state.apiURL + 'companies/' + this.$route.params.company_id + '/users/get-by-email';

                const data = {
                    email: this.editUser.email
                };

                axios({
                    url: url,
                    data: data,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        if (response.data.data && response.data.data.id) {
                            this.editUser = response.data.data;
                        }

                        this.userValidated = true;

                    })
                    .catch((error) => {
                        if (error.response.data.message) {
                            if (this.editUser.id && this.user.email === this.editUser.email) {
                                this.editUser = cloneDeep(this.user);
                                this.userValidated = true;
                            } else {
                                this.errors.email = [error.response.data.message];
                            }
                        } else {
                            this.errors.email = ['Something went wrong while validating the email. Please try again.'];
                        }
                    });
            } else {
                this.errors.email = ['Invalid email address'];
            }

        },
        saveUser(bvModalEvt) {
            bvModalEvt.preventDefault();

            let token = this.$store.state.token;

            let method;
            let url = this.$store.state.apiURL + 'companies/' + this.$route.params.company_id + '/users';

            if (this.editUser.id) {
                url += '/' + this.editUser.id;
                method = 'PUT';
            } else {
                method = 'POST';
            }


            let data = this.editUser;
            data.password = this.password;
            data.password_confirmation = this.password_confirmation;

            axios({
                url: url,
                data: data,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.$emit('userSaved');
                })
                .catch((error, data) => {
                    const responseData = error.response.data;
                    if (typeof responseData.errors !== 'undefined') {

                        for (const [key, error] of Object.entries(responseData.errors)) {
                            this.errors[key] = error;
                            console.log('setting', error, key);
                        }
                    } else if (typeof responseData.message !== 'undefined') {
                        alert(responseData.message);
                    } else {
                        alert('Something went wrong');
                    }
                });
        }
    },
    watch: {
        editUser() {
            this.password = null;
            this.password_confirmation = null;
        }
    },
    computed: {
        roles() {
            let roles = this.roleArray.filter(role => {
                // TODO: return only lower level roles (remove the '=' operator).
                // This is already enforced in backend validation, so there's no
                // sense to display any unavailable roles. It's left here only for
                // testing purposes to test that the validation works as expected.
                return this.isReseller || role.id >= (this.userCompany?.role ?? 9999);
            });

            if (this.editUser.has_unique_role) {
                roles = roles.filter(role => {
                    if (this.user.id && this.user.role.id === role.id) {
                        return true;
                    }

                    return !role.is_unique;
                });
            }

            return roles;
        },
        userCompany() {
            return this.getUserCompany(this.$store.state.company.id);
        }
    },

}
</script>
